












module.exports =
  name: 'period_accounts'
  props: ['transactions']
  data: ->
    accounts:
      included: []
      excluded: []
  mounted: ->
    @$watch 'accounts', (=> @$emit 'change', @accounts), { deep: true }
  computed:
    account_categories: -> @$store.getters.account_categories
